import { Generic } from './Carousel';
export function isCarousel(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isCarousel;    //# sourceMappingURL=isCarousel.js.map
